export default [
  {
    path: 'contacts',
    name: 'contacts',
    component: () => import('@/views/pages/front/contacts/Contacts.vue'),
    meta: {
      pageTitle: 'Contacts',
      breadcrumb: [
        {
          text: 'Contacts',
          active: true,
        },
      ],
    },
  },
]
